import $ from 'jquery';
import inpageHeadlineTemplate from 'tmpl/inpage-headline.hbs';
import Handlebars from 'handlebars';
import 'lib/helpers/ifCond';
import langFromUrl from 'lib/util/langFromUrl';
import breadCrumbs from 'features/breadcrumbs/breadcrumbs';

var __tmplInpageHeadline = Handlebars.compile(inpageHeadlineTemplate);

var inpageHeadlineObj = {

  // legacy function for the old way
  initOld: function () {
    /* GET CURRENT LOCATION AND SET VALUES >>
    *
    * facebook title, description, and image handled in meta open graph tags
    * google+ title and image handled in meta open graph tags
    * current test url: http://projects.organic.com/fb_test/test.html
    *
    */

    var pageUrl = encodeURI(document.location);
    var pubId = 'ra-5342df2d3e0f72f8';
    var textTwitter = 'Take%20a%20look%20at%20this%20page%20on%20BuyaToyota.com';
    var relatedTwitter = 'toyota';
    var titleEmail = 'Take%20a%20look%20at%20this%20page%20on%20BuyaToyota.com';
    var fromEmail = 'noreply@toyota.com';
    var noteEmail = 'A%20page%20has%20been%20shared%20with%20you';

    if ($('.share-wraps').length > 0) {
      $('.ebrochure-link').insertBefore($('.share-wraps'));
    } else {
      $('.ebrochure-link').insertAfter($('#inpage-headline'));
      $('.ebrochure-link').css('margin-top','0px');
      $('.ebrochure-link').css('margin-right','0px');
    }

    /* ----- SHARE TOOLS ROLLOVERS ----- */

    $('.share-wraps').hover(function () {
      $('.inpage-share-tools-wrap').fadeIn(200);
    },
    function () {
      $('.inpage-share-tools-wrap').fadeOut(200);
    });


    /* ADA BAT-3846: EXPOSE SHARES ON KEYOARD TAB IN, EMULATE CLICK ON SPACE AND ENTER KEYS. */
    $('.inpage-share-icon-wrap').on('focusin', function (event) {
      var isMouse = $('.inpage-share-tools-wrap').hasClass('using-mouse');
      if (!isMouse) {
        $('.inpage-share-tools-wrap').fadeIn(200);
      }
    });

    $('.icon-share-svg-img').on('focusout', function (event) { // onfocusout="socialFocusOut(event)"
      setTimeout(function () {
        var $activEl = $(document.activeElement);
        if (!$activEl.hasClass('icon-share-svg-img')) {
          $('.inpage-share-tools-wrap').fadeOut(200);
        }
      }, 1000);
    });

    // the share icons:
    $('.icon-share-svg-img').on('keydown', function (event) {
      if (event.keyCode === 9) { // allow tabbing.
        return;
      }
      // SPACE and ENTER
      if (event.keyCode === 32 || event.keyCode === 13) {
        var $ect = $(event.currentTarget);
        if ($ect.hasClass('facebook')) {
          $('.inpage-share-tools-wrap').find('.facebook').trigger('click');
        }
        if ($ect.hasClass('twitter')) {
          $('.inpage-share-tools-wrap').find('.twitter').trigger('click');
        }
        if ($ect.hasClass('plus')) {
          $('.inpage-share-tools-wrap').find('.plus').trigger('click');
        }
        $('.inpage-share-tools-wrap').hide();
        event.preventDefault();
      }
    });
    /* END BAT-3846 */
    /* ----- SHARE TOOLS CLICKS -----*/
    $('.inpage-share-tools-wrap').find('.facebook').click(function (e) {
      e.preventDefault();

      // handle addthis facebook (og meta tags handle title)
      window.open('http://api.addthis.com/oexchange/0.8/forward/facebook/offer' +
        '?url=' + pageUrl +
        '&pubid=' + pubId, '', 'directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=yes,width=400,height=350');
      $('.inpage-share-tools-wrap').hide();
    });

    $('.inpage-share-tools-wrap').find('.twitter').click(function (e) {
      e.preventDefault();
      // handle addthis twitter
      window.open('http://api.addthis.com/oexchange/0.8/forward/twitter/offer' +
        '?url=' + pageUrl +
        '&pubid=' + pubId +
        '&text=' + textTwitter +
        '&related=' + relatedTwitter, '', 'directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=yes,width=400,height=480');
      $('.inpage-share-tools-wrap').hide();
    });

    $('.inpage-share-tools-wrap').find('.plus').click(function (e) {
      e.preventDefault();
      // handle addthis google+
      window.open('http://api.addthis.com/oexchange/0.8/forward/google_plusone_share/offer' +
        '?url=' + pageUrl +
        '&pubid=' + pubId, '', 'directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=yes,width=450,height=640');
      $('.inpage-share-tools-wrap').hide();
    });

    $('.inpage-share-tools-wrap').find('.email').click(function (e) {
      e.preventDefault();

      // handle addthis email
      window.open('http://api.addthis.com/oexchange/0.8/forward/email/offer' +
        '?url=' + pageUrl +
        '&pubid=' + pubId +
        '&title=' + titleEmail +
        '&from=' + fromEmail +
        '&var_offers=' + encodeURI(window.location.origin + '/en/offers/') +
        '&var_vehicles=' + encodeURI(window.location.origin + '/en/vehicles/') +
        '&var_dealers=' + encodeURI(window.location.origin + '/en/dealers/') +
        '&note=' + noteEmail, '', 'directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=yes,width=480,height=600');
      $('.inpage-share-tools-wrap').hide();
    });

    breadCrumbs.displayBreadcrumbs();
  },

  init: function (el, config) {
    var self = this;
    self._el = el;
    self._config = config;
    self.$el = $(el);

    var breadCrumb = breadCrumbs.buildBreadcrumbs();
    self.$el.append(__tmplInpageHeadline({
      inpageHeadline: config,
      breadCrumb: breadCrumb,
      lang: langFromUrl(),
    }));
    breadCrumbs.displayBreadcrumbs();

    self.ebrochureLink(self.$el);
    self.shareTools(self.$el);
  },

  // $scope would be .ebrochure-link
  ebrochureLink: function ($scope) {
    var $ebrochureLink = $scope.find($('ebrochure-link'));
    var $shareTools = $scope.find($('.share-wraps'));

    if ($shareTools.length > 0) {
      $ebrochureLink.insertBefore($shareTools[0]);
    } else {
      $ebrochureLink.insertAfter($('#inpage-headline'));
      $ebrochureLink.css('margin-top', '0px');
      $ebrochureLink.css('margin-right', '0px');
    }
  },
  // $scope would be .share-wraps for example
  shareTools: function ($scope) {
    /* GET CURRENT LOCATION AND SET VALUES >>
    *
    * facebook title, description, and image handled in meta open graph tags
    * google+ title and image handled in meta open graph tags
    * current test url: http://projects.organic.com/fb_test/test.html
    *
    */
    var _pageUrl = encodeURI(document.location);
    var _pubId = 'ra-5342df2d3e0f72f8_';
    var _textTwitter = 'Take%20a%20look%20at%20this%20page%20on%20BuyaToyota.com';
    var _relatedTwitter = 'toyota';
    var _titleEmail = 'Take%20a%20look%20at%20this%20page%20on%20BuyaToyota.com';
    var _fromEmail = 'noreply@toyota.com';
    var _noteEmail = 'A%20page%20has%20been%20shared%20with%20you';

    // share elements from the scope
    var _shareWrapsElement = $scope.find('.share-wraps');
    var _toolsIconWrapElement = $scope.find('.icon-share-3');
    _toolsIconWrapElement.attr('aria-expanded', true);
    var _toolsWrapElement = $scope.find('.inpage-share-tools-wrap');
    var _toolsWrapChildrenElements = _toolsWrapElement.find('.icon-share-svg-img');

    /* ----- SHARE TOOLS ROLLOVERS ----- */
    _shareWrapsElement.hover(function () {
      _toolsWrapElement.fadeIn(200);
    },
    function () {
      _toolsWrapElement.fadeOut(200);
    });

    /**
     * ADA BAT-3846: EXPOSE SHARES ON KEYOARD TAB IN, EMULATE CLICK ON SPACE AND ENTER KEYS.
     * BAT-5032: Move functions out of the window obj.
     */

    // bind functions to share icons
    _toolsIconWrapElement.on('focusin', function () {
      var isMouse = _toolsWrapElement.hasClass('using-mouse');
      if (!isMouse) {
        _toolsIconWrapElement.attr('aria-expanded', true);
        _toolsWrapElement.fadeIn(200);
      }
    });
    _toolsWrapChildrenElements.on('focusout', function () { // onfocusout="socialFocusOut(event)"
      setTimeout(function () {
        var $activEl = $(document.activeElement);
        if (!$activEl.hasClass('icon-share-svg-img')) {
          _toolsIconWrapElement.attr('aria-expanded', false);
          _toolsWrapElement.fadeOut(200);
        }
      }, 1000);
    });
    _toolsWrapChildrenElements.on('keydown', function (event) {
      if (event.keyCode === 9) { // allow tabbing.
        return;
      }
      // SPACE and ENTER
      if (event.keyCode === 32 || event.keyCode === 13) {
        var $ect = $(event.currentTarget);
        if ($ect.hasClass('facebook')) {
          _toolsWrapElement.find('.facebook').trigger('click');
        }
        if ($ect.hasClass('twitter')) {
          _toolsWrapElement.find('.twitter').trigger('click');
        }
        if ($ect.hasClass('plus')) {
          _toolsWrapElement.find('.plus').trigger('click');
        }
        _toolsWrapElement.hide();
        event.preventDefault();
      }
    });
    /* END BAT-3846 */

    /* ----- SHARE TOOLS CLICKS -----*/
    _toolsWrapElement.find('.facebook').click(function (e) {
      e.preventDefault();

      // handle addthis facebook (og meta tags handle title)
      window.open('http://api.addthis.com/oexchange/0.8/forward/facebook/offer'
        + '?url=' + _pageUrl
        + '&pubid=' + _pubId, '', 'directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,'
        + 'scrollbars=no,resizable=yes,width=400,height=350');
      _toolsWrapElement.hide();
    });

    _toolsWrapElement.find('.twitter').click(function (e) {
      e.preventDefault();
      // handle addthis twitter
      window.open('http://api.addthis.com/oexchange/0.8/forward/twitter/offer'
        + '?url=' + _pageUrl
        + '&pubid=' + _pubId
        + '&text=' + _textTwitter
        + '&related=' + _relatedTwitter, '', 'directories=no,titlebar=no,toolbar=no,location=no,status=no,'
        + 'menubar=no,scrollbars=no,resizable=yes,width=400,height=480');
      $('.inpage-share-tools-wrap').hide();
    });

    $('.inpage-share-tools-wrap').find('.plus').click(function (e) {
      e.preventDefault();
      // handle addthis google+
      window.open('http://api.addthis.com/oexchange/0.8/forward/google_plusone_share/offer'
        + '?url=' + _pageUrl
        + '&pubid=' + _pubId, '', 'directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,'
        + 'scrollbars=no,resizable=yes,width=450,height=640');
      $('.inpage-share-tools-wrap').hide();
    });

    $('.inpage-share-tools-wrap').find('.email').click(function (e) {
      e.preventDefault();

      // handle addthis email
      window.open('http://api.addthis.com/oexchange/0.8/forward/email/offer'
        + '?url=' + _pageUrl
        + '&pubid=' + _pubId
        + '&title=' + _titleEmail
        + '&from=' + _fromEmail
        + '&var_offers=' + encodeURI(window.location.origin + '/en/offers/')
        + '&var_vehicles=' + encodeURI(window.location.origin + '/en/vehicles/')
        + '&var_dealers=' + encodeURI(window.location.origin + '/en/dealers/')
        + '&note=' + _noteEmail, '', 'directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,'
        + 'scrollbars=no,resizable=yes,width=480,height=600');
      $('.inpage-share-tools-wrap').hide();
    });
  },

  changeTitleDetail: function (year, name, series) {
    var title = year + ' ' + name;
    title = title.replace(/\s(\w+\s)\1/, ' $1');
    $('#inpage-headline').html(title);
    $('#inventory-detail').data('series', series);
  }
};
export default inpageHeadlineObj;
